import React, { MouseEvent, useState } from 'react';
import PinField from 'react-pin-field';
import styles from './CodeConfirmation.module.scss';
import cx from 'classnames';
import { Text } from 'components';
import { useCountdown } from 'hooks';

type Props = {
  userEmail: string;
  setPin(pin: string): void;
  errorMessage?: string;
  onResend(): void;
};

const COUNTDOWN_SECONDS = 60;

export const CodeConfirmation = ({ userEmail, errorMessage, setPin, onResend }: Props) => {
  const [initialTime, setInitialTime] = useState({ initialTime: COUNTDOWN_SECONDS });
  const [time] = useCountdown(initialTime);
  const minutes = String(Math.floor(time / 60)).padStart(2, '0');
  const seconds = String(time - Number(minutes) * 60).padStart(2, '0');

  const onPinChange = (code: string) => {
    setPin(code);
  };

  const onResendHandler = (e: MouseEvent) => {
    e.preventDefault();
    setInitialTime({ initialTime: COUNTDOWN_SECONDS });
    onResend();
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>
          <Text type="body2" className={styles.textBeforeEmail}>
            Confirmation code is sent to
          </Text>
          <Text type="subtitle2" className={styles.email}>
            {userEmail}
          </Text>
        </div>
        <Text type="body2">The code is valid for 24 hours or until resend</Text>
      </div>
      <div className={styles.passwordContainer}>
        <div className={styles.passwordField}>
          <Text type="caption">Enter confirmation code</Text>
          <div className={styles.inputsContainer}>
            <PinField
              length={6}
              onChange={onPinChange}
              autoComplete="off"
              type="number"
              inputMode="numeric"
              pattern="[0-9]*"
            />
          </div>
          {errorMessage && (
            <Text type="caption" className={styles.error}>
              {errorMessage}
            </Text>
          )}
        </div>
        <div className={styles.resendControls}>
          <button className={cx(styles.resendButton, { [styles.disabled]: time > 0 })} onClick={onResendHandler}>
            Resend confirmation code in
          </button>
          {time > 0 && (
            <Text type="body2">
              {minutes}:{seconds}
            </Text>
          )}
        </div>
      </div>
    </div>
  );
};
